import styled from "styled-components";

export const ScheduleWrapper = styled.div`
  .schedule-header {
    display: flex;
  }

  .schedule_title {
    display: flex;
    align-items: center;
    margin-left: 3px;
    margin-right: 3px;
   
  }
`;
